export enum ClientTableViewColumnLabels {
  ClientCode = 'Client Code',
  ZoneCode = 'Zone Code',
  Active = 'Active',
  Name = 'Name',
  ZoneName = 'Zone Name',
  CustomerGroup = 'Customer Group',
  Master = 'Master',
  ReorderStatus = 'Reorder',
  Country = 'Country',
  Zone = 'Sales Region',
  Doors = 'Doors',
  Open = 'Open',
  PriceGroup = 'Price Group',
  SalesDistrict = 'Sales District',
  Actions = 'Actions'
}
